import { Box, Flex, HStack, Text, useColorModeValue } from "@chakra-ui/react";

type CommentCardProps = {
  senderName: string;
  sentDate: string;
  comment: string;
  isAuthor?: boolean;
};

const CommentCard = ({
  comment,
  senderName,
  sentDate,
  isAuthor
}: CommentCardProps) => {
  const bgColor = useColorModeValue(
    isAuthor ? "gray.200" : "main.100",
    isAuthor ? "gray.600" : "main.400"
  );
  return (
    <Flex
      my={2}
      width="full"
      justifyContent={isAuthor ? "flex-start" : "flex-end"}
    >
      <Box
        width="max-content"
        p={3}
        rounded="xl"
        bg={bgColor}
        borderTopLeftRadius={isAuthor ? 0 : undefined}
        borderTopRightRadius={isAuthor ? undefined : 0}
      >
        <HStack alignItems="flex-end" lineHeight={1}>
          <Text fontWeight="bold">{senderName}</Text>
          <Text fontSize="xs" ml={4} color="muted.400">
            {sentDate}
          </Text>
        </HStack>
        <HStack justify={isAuthor ? "flex-end" : "flex-start"}>
          <Text w="70%" textAlign={isAuthor ? "right" : "left"} my={2}>
            {comment}
          </Text>
        </HStack>
      </Box>
    </Flex>
  );
};

export { CommentCard };
